// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v6.33.4
// source: voice.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "voice";

export interface ElevenLabsTtsConfig {
  modelId: string;
  similarityBoost: number;
  stability: number;
  speed?: number | undefined;
}

export interface PlayHTTtsConfig {
}

export interface CartesiaTtsConfig {
  modelId: string;
  speed?: number | undefined;
  emotion?: string | undefined;
  volume?: number | undefined;
}

export interface HumeTtsConfig {
  modelId: string;
  voiceDescription?: string | undefined;
  instantMode?: boolean | undefined;
  provider?: string | undefined;
}

export interface Voice {
  voiceId: string;
  createdBy: string;
  createdAt: Date | undefined;
  updatedBy: string;
  updatedAt: Date | undefined;
  settings:
    | { $case: "elevenLabs"; value: ElevenLabsTtsConfig }
    | { $case: "playHt"; value: PlayHTTtsConfig }
    | { $case: "cartesia"; value: CartesiaTtsConfig }
    | { $case: "hume"; value: HumeTtsConfig }
    | undefined;
  id: string;
}

export interface AgentVoice {
  voiceId: string;
  probability: number;
  updatedBy: string;
  updatedAt: Date | undefined;
  languageCode?: string | undefined;
  id: string;
}

export interface DisclaimerVoice {
  voiceId: string;
  updatedBy: string;
  updatedAt: Date | undefined;
  languageCode?: string | undefined;
}

export interface FavoriteVoice {
  voiceId: string;
  accountId: string;
  createdBy: string;
  createdAt: Date | undefined;
  updatedBy: string;
  updatedAt: Date | undefined;
}

export interface Voices {
  agentVoices: AgentVoice[];
  disclaimerVoices: DisclaimerVoice[];
  agentVoiceSettings: Voice[];
  disclaimerVoiceSettings: Voice[];
  favoriteVoices: FavoriteVoice[];
}

export interface VoiceAddAgentVoice {
  voiceId: string;
  probability: number;
  languageCode?: string | undefined;
  id: string;
}

export interface VoiceDeleteAgentVoice {
  /** @deprecated */
  voiceId: string;
  id: string;
}

export interface VoiceUpdateAgentVoice {
  /** @deprecated */
  voiceId: string;
  probability: number;
  newVoiceId?: string | undefined;
  id: string;
}

export interface VoiceCreateAgentVoiceSettings {
  /** Maps to `id` field of message Voice */
  voiceId: string;
  settings:
    | { $case: "elevenLabs"; value: ElevenLabsTtsConfig }
    | { $case: "playHt"; value: PlayHTTtsConfig }
    | { $case: "cartesia"; value: CartesiaTtsConfig }
    | { $case: "hume"; value: HumeTtsConfig }
    | undefined;
}

export interface VoiceUpdateAgentVoiceSettings {
  voiceId: string;
  settings:
    | { $case: "elevenLabs"; value: ElevenLabsTtsConfig }
    | { $case: "playHt"; value: PlayHTTtsConfig }
    | { $case: "cartesia"; value: CartesiaTtsConfig }
    | { $case: "hume"; value: HumeTtsConfig }
    | undefined;
}

export interface VoiceUpdateDisclaimerVoice {
  voiceId: string;
  languageCode?: string | undefined;
}

export interface VoiceCreateDisclaimerVoiceSettings {
  voiceId: string;
  settings:
    | { $case: "elevenLabs"; value: ElevenLabsTtsConfig }
    | { $case: "playHt"; value: PlayHTTtsConfig }
    | { $case: "cartesia"; value: CartesiaTtsConfig }
    | { $case: "hume"; value: HumeTtsConfig }
    | undefined;
}

export interface VoiceUpdateDisclaimerVoiceSettings {
  voiceId: string;
  settings:
    | { $case: "elevenLabs"; value: ElevenLabsTtsConfig }
    | { $case: "playHt"; value: PlayHTTtsConfig }
    | { $case: "cartesia"; value: CartesiaTtsConfig }
    | { $case: "hume"; value: HumeTtsConfig }
    | undefined;
}

export interface VoiceAddFavoriteVoice {
  voiceId: string;
  accountId: string;
}

export interface VoiceRemoveFavoriteVoice {
  voiceId: string;
  accountId: string;
}

function createBaseElevenLabsTtsConfig(): ElevenLabsTtsConfig {
  return { modelId: "", similarityBoost: 0, stability: 0, speed: undefined };
}

export const ElevenLabsTtsConfig: MessageFns<ElevenLabsTtsConfig> = {
  encode(message: ElevenLabsTtsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    if (message.similarityBoost !== 0) {
      writer.uint32(17).double(message.similarityBoost);
    }
    if (message.stability !== 0) {
      writer.uint32(25).double(message.stability);
    }
    if (message.speed !== undefined) {
      writer.uint32(33).double(message.speed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ElevenLabsTtsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseElevenLabsTtsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.similarityBoost = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.stability = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.speed = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ElevenLabsTtsConfig {
    return {
      modelId: isSet(object.modelId)
        ? globalThis.String(object.modelId)
        : isSet(object.model_id)
        ? globalThis.String(object.model_id)
        : "",
      similarityBoost: isSet(object.similarityBoost)
        ? globalThis.Number(object.similarityBoost)
        : isSet(object.similarity_boost)
        ? globalThis.Number(object.similarity_boost)
        : 0,
      stability: isSet(object.stability) ? globalThis.Number(object.stability) : 0,
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : undefined,
    };
  },

  toJSON(message: ElevenLabsTtsConfig): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.similarityBoost !== 0) {
      obj.similarityBoost = message.similarityBoost;
    }
    if (message.stability !== 0) {
      obj.stability = message.stability;
    }
    if (message.speed !== undefined) {
      obj.speed = message.speed;
    }
    return obj;
  },

  create(base?: DeepPartial<ElevenLabsTtsConfig>): ElevenLabsTtsConfig {
    return ElevenLabsTtsConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ElevenLabsTtsConfig>): ElevenLabsTtsConfig {
    const message = createBaseElevenLabsTtsConfig();
    message.modelId = object.modelId ?? "";
    message.similarityBoost = object.similarityBoost ?? 0;
    message.stability = object.stability ?? 0;
    message.speed = object.speed ?? undefined;
    return message;
  },
};

function createBasePlayHTTtsConfig(): PlayHTTtsConfig {
  return {};
}

export const PlayHTTtsConfig: MessageFns<PlayHTTtsConfig> = {
  encode(_: PlayHTTtsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlayHTTtsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlayHTTtsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PlayHTTtsConfig {
    return {};
  },

  toJSON(_: PlayHTTtsConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<PlayHTTtsConfig>): PlayHTTtsConfig {
    return PlayHTTtsConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<PlayHTTtsConfig>): PlayHTTtsConfig {
    const message = createBasePlayHTTtsConfig();
    return message;
  },
};

function createBaseCartesiaTtsConfig(): CartesiaTtsConfig {
  return { modelId: "", speed: undefined, emotion: undefined, volume: undefined };
}

export const CartesiaTtsConfig: MessageFns<CartesiaTtsConfig> = {
  encode(message: CartesiaTtsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    if (message.speed !== undefined) {
      writer.uint32(17).double(message.speed);
    }
    if (message.emotion !== undefined) {
      writer.uint32(26).string(message.emotion);
    }
    if (message.volume !== undefined) {
      writer.uint32(33).double(message.volume);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CartesiaTtsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCartesiaTtsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.speed = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.emotion = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.volume = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CartesiaTtsConfig {
    return {
      modelId: isSet(object.modelId)
        ? globalThis.String(object.modelId)
        : isSet(object.model_id)
        ? globalThis.String(object.model_id)
        : "",
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : undefined,
      emotion: isSet(object.emotion) ? globalThis.String(object.emotion) : undefined,
      volume: isSet(object.volume) ? globalThis.Number(object.volume) : undefined,
    };
  },

  toJSON(message: CartesiaTtsConfig): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.speed !== undefined) {
      obj.speed = message.speed;
    }
    if (message.emotion !== undefined) {
      obj.emotion = message.emotion;
    }
    if (message.volume !== undefined) {
      obj.volume = message.volume;
    }
    return obj;
  },

  create(base?: DeepPartial<CartesiaTtsConfig>): CartesiaTtsConfig {
    return CartesiaTtsConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CartesiaTtsConfig>): CartesiaTtsConfig {
    const message = createBaseCartesiaTtsConfig();
    message.modelId = object.modelId ?? "";
    message.speed = object.speed ?? undefined;
    message.emotion = object.emotion ?? undefined;
    message.volume = object.volume ?? undefined;
    return message;
  },
};

function createBaseHumeTtsConfig(): HumeTtsConfig {
  return { modelId: "", voiceDescription: undefined, instantMode: undefined, provider: undefined };
}

export const HumeTtsConfig: MessageFns<HumeTtsConfig> = {
  encode(message: HumeTtsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    if (message.voiceDescription !== undefined) {
      writer.uint32(18).string(message.voiceDescription);
    }
    if (message.instantMode !== undefined) {
      writer.uint32(24).bool(message.instantMode);
    }
    if (message.provider !== undefined) {
      writer.uint32(34).string(message.provider);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HumeTtsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHumeTtsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.voiceDescription = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.instantMode = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HumeTtsConfig {
    return {
      modelId: isSet(object.modelId)
        ? globalThis.String(object.modelId)
        : isSet(object.model_id)
        ? globalThis.String(object.model_id)
        : "",
      voiceDescription: isSet(object.voiceDescription)
        ? globalThis.String(object.voiceDescription)
        : isSet(object.voice_description)
        ? globalThis.String(object.voice_description)
        : undefined,
      instantMode: isSet(object.instantMode)
        ? globalThis.Boolean(object.instantMode)
        : isSet(object.instant_mode)
        ? globalThis.Boolean(object.instant_mode)
        : undefined,
      provider: isSet(object.provider) ? globalThis.String(object.provider) : undefined,
    };
  },

  toJSON(message: HumeTtsConfig): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.voiceDescription !== undefined) {
      obj.voiceDescription = message.voiceDescription;
    }
    if (message.instantMode !== undefined) {
      obj.instantMode = message.instantMode;
    }
    if (message.provider !== undefined) {
      obj.provider = message.provider;
    }
    return obj;
  },

  create(base?: DeepPartial<HumeTtsConfig>): HumeTtsConfig {
    return HumeTtsConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HumeTtsConfig>): HumeTtsConfig {
    const message = createBaseHumeTtsConfig();
    message.modelId = object.modelId ?? "";
    message.voiceDescription = object.voiceDescription ?? undefined;
    message.instantMode = object.instantMode ?? undefined;
    message.provider = object.provider ?? undefined;
    return message;
  },
};

function createBaseVoice(): Voice {
  return {
    voiceId: "",
    createdBy: "",
    createdAt: undefined,
    updatedBy: "",
    updatedAt: undefined,
    settings: undefined,
    id: "",
  };
}

export const Voice: MessageFns<Voice> = {
  encode(message: Voice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.createdBy !== "") {
      writer.uint32(18).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(34).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    switch (message.settings?.$case) {
      case "elevenLabs":
        ElevenLabsTtsConfig.encode(message.settings.value, writer.uint32(50).fork()).join();
        break;
      case "playHt":
        PlayHTTtsConfig.encode(message.settings.value, writer.uint32(58).fork()).join();
        break;
      case "cartesia":
        CartesiaTtsConfig.encode(message.settings.value, writer.uint32(66).fork()).join();
        break;
      case "hume":
        HumeTtsConfig.encode(message.settings.value, writer.uint32(74).fork()).join();
        break;
    }
    if (message.id !== "") {
      writer.uint32(82).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Voice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.settings = { $case: "playHt", value: PlayHTTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.settings = { $case: "hume", value: HumeTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Voice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      settings: isSet(object.elevenLabs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.elevenLabs) }
        : isSet(object.eleven_labs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.eleven_labs) }
        : isSet(object.playHt)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.playHt) }
        : isSet(object.play_ht)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.play_ht) }
        : isSet(object.cartesia)
        ? { $case: "cartesia", value: CartesiaTtsConfig.fromJSON(object.cartesia) }
        : isSet(object.hume)
        ? { $case: "hume", value: HumeTtsConfig.fromJSON(object.hume) }
        : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: Voice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.settings?.$case === "elevenLabs") {
      obj.elevenLabs = ElevenLabsTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "playHt") {
      obj.playHt = PlayHTTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "cartesia") {
      obj.cartesia = CartesiaTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "hume") {
      obj.hume = HumeTtsConfig.toJSON(message.settings.value);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<Voice>): Voice {
    return Voice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Voice>): Voice {
    const message = createBaseVoice();
    message.voiceId = object.voiceId ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    switch (object.settings?.$case) {
      case "elevenLabs": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "playHt": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "playHt", value: PlayHTTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "cartesia": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "hume": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "hume", value: HumeTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
    }
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseAgentVoice(): AgentVoice {
  return { voiceId: "", probability: 0, updatedBy: "", updatedAt: undefined, languageCode: undefined, id: "" };
}

export const AgentVoice: MessageFns<AgentVoice> = {
  encode(message: AgentVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.probability !== 0) {
      writer.uint32(17).double(message.probability);
    }
    if (message.updatedBy !== "") {
      writer.uint32(26).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    if (message.languageCode !== undefined) {
      writer.uint32(42).string(message.languageCode);
    }
    if (message.id !== "") {
      writer.uint32(50).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.probability = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      probability: isSet(object.probability) ? globalThis.Number(object.probability) : 0,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: AgentVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.probability !== 0) {
      obj.probability = message.probability;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.languageCode !== undefined) {
      obj.languageCode = message.languageCode;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<AgentVoice>): AgentVoice {
    return AgentVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AgentVoice>): AgentVoice {
    const message = createBaseAgentVoice();
    message.voiceId = object.voiceId ?? "";
    message.probability = object.probability ?? 0;
    message.updatedBy = object.updatedBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.languageCode = object.languageCode ?? undefined;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseDisclaimerVoice(): DisclaimerVoice {
  return { voiceId: "", updatedBy: "", updatedAt: undefined, languageCode: undefined };
}

export const DisclaimerVoice: MessageFns<DisclaimerVoice> = {
  encode(message: DisclaimerVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.updatedBy !== "") {
      writer.uint32(18).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    if (message.languageCode !== undefined) {
      writer.uint32(34).string(message.languageCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisclaimerVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisclaimerVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DisclaimerVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : undefined,
    };
  },

  toJSON(message: DisclaimerVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.languageCode !== undefined) {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create(base?: DeepPartial<DisclaimerVoice>): DisclaimerVoice {
    return DisclaimerVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DisclaimerVoice>): DisclaimerVoice {
    const message = createBaseDisclaimerVoice();
    message.voiceId = object.voiceId ?? "";
    message.updatedBy = object.updatedBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.languageCode = object.languageCode ?? undefined;
    return message;
  },
};

function createBaseFavoriteVoice(): FavoriteVoice {
  return { voiceId: "", accountId: "", createdBy: "", createdAt: undefined, updatedBy: "", updatedAt: undefined };
}

export const FavoriteVoice: MessageFns<FavoriteVoice> = {
  encode(message: FavoriteVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    if (message.createdBy !== "") {
      writer.uint32(26).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(42).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FavoriteVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFavoriteVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FavoriteVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
        ? globalThis.String(object.account_id)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: FavoriteVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<FavoriteVoice>): FavoriteVoice {
    return FavoriteVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FavoriteVoice>): FavoriteVoice {
    const message = createBaseFavoriteVoice();
    message.voiceId = object.voiceId ?? "";
    message.accountId = object.accountId ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseVoices(): Voices {
  return {
    agentVoices: [],
    disclaimerVoices: [],
    agentVoiceSettings: [],
    disclaimerVoiceSettings: [],
    favoriteVoices: [],
  };
}

export const Voices: MessageFns<Voices> = {
  encode(message: Voices, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.agentVoices) {
      AgentVoice.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.disclaimerVoices) {
      DisclaimerVoice.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.agentVoiceSettings) {
      Voice.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.disclaimerVoiceSettings) {
      Voice.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.favoriteVoices) {
      FavoriteVoice.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Voices {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoices();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.agentVoices.push(AgentVoice.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.disclaimerVoices.push(DisclaimerVoice.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.agentVoiceSettings.push(Voice.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.disclaimerVoiceSettings.push(Voice.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.favoriteVoices.push(FavoriteVoice.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Voices {
    return {
      agentVoices: globalThis.Array.isArray(object?.agentVoices)
        ? object.agentVoices.map((e: any) => AgentVoice.fromJSON(e))
        : globalThis.Array.isArray(object?.agent_voices)
        ? object.agent_voices.map((e: any) => AgentVoice.fromJSON(e))
        : [],
      disclaimerVoices: globalThis.Array.isArray(object?.disclaimerVoices)
        ? object.disclaimerVoices.map((e: any) => DisclaimerVoice.fromJSON(e))
        : globalThis.Array.isArray(object?.disclaimer_voices)
        ? object.disclaimer_voices.map((e: any) => DisclaimerVoice.fromJSON(e))
        : [],
      agentVoiceSettings: globalThis.Array.isArray(object?.agentVoiceSettings)
        ? object.agentVoiceSettings.map((e: any) => Voice.fromJSON(e))
        : globalThis.Array.isArray(object?.agent_voice_settings)
        ? object.agent_voice_settings.map((e: any) => Voice.fromJSON(e))
        : [],
      disclaimerVoiceSettings: globalThis.Array.isArray(object?.disclaimerVoiceSettings)
        ? object.disclaimerVoiceSettings.map((e: any) => Voice.fromJSON(e))
        : globalThis.Array.isArray(object?.disclaimer_voice_settings)
        ? object.disclaimer_voice_settings.map((e: any) => Voice.fromJSON(e))
        : [],
      favoriteVoices: globalThis.Array.isArray(object?.favoriteVoices)
        ? object.favoriteVoices.map((e: any) => FavoriteVoice.fromJSON(e))
        : globalThis.Array.isArray(object?.favorite_voices)
        ? object.favorite_voices.map((e: any) => FavoriteVoice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Voices): unknown {
    const obj: any = {};
    if (message.agentVoices?.length) {
      obj.agentVoices = message.agentVoices.map((e) => AgentVoice.toJSON(e));
    }
    if (message.disclaimerVoices?.length) {
      obj.disclaimerVoices = message.disclaimerVoices.map((e) => DisclaimerVoice.toJSON(e));
    }
    if (message.agentVoiceSettings?.length) {
      obj.agentVoiceSettings = message.agentVoiceSettings.map((e) => Voice.toJSON(e));
    }
    if (message.disclaimerVoiceSettings?.length) {
      obj.disclaimerVoiceSettings = message.disclaimerVoiceSettings.map((e) => Voice.toJSON(e));
    }
    if (message.favoriteVoices?.length) {
      obj.favoriteVoices = message.favoriteVoices.map((e) => FavoriteVoice.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Voices>): Voices {
    return Voices.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Voices>): Voices {
    const message = createBaseVoices();
    message.agentVoices = object.agentVoices?.map((e) => AgentVoice.fromPartial(e)) || [];
    message.disclaimerVoices = object.disclaimerVoices?.map((e) => DisclaimerVoice.fromPartial(e)) || [];
    message.agentVoiceSettings = object.agentVoiceSettings?.map((e) => Voice.fromPartial(e)) || [];
    message.disclaimerVoiceSettings = object.disclaimerVoiceSettings?.map((e) => Voice.fromPartial(e)) || [];
    message.favoriteVoices = object.favoriteVoices?.map((e) => FavoriteVoice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVoiceAddAgentVoice(): VoiceAddAgentVoice {
  return { voiceId: "", probability: 0, languageCode: undefined, id: "" };
}

export const VoiceAddAgentVoice: MessageFns<VoiceAddAgentVoice> = {
  encode(message: VoiceAddAgentVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.probability !== 0) {
      writer.uint32(17).double(message.probability);
    }
    if (message.languageCode !== undefined) {
      writer.uint32(26).string(message.languageCode);
    }
    if (message.id !== "") {
      writer.uint32(34).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceAddAgentVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceAddAgentVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.probability = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceAddAgentVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      probability: isSet(object.probability) ? globalThis.Number(object.probability) : 0,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: VoiceAddAgentVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.probability !== 0) {
      obj.probability = message.probability;
    }
    if (message.languageCode !== undefined) {
      obj.languageCode = message.languageCode;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceAddAgentVoice>): VoiceAddAgentVoice {
    return VoiceAddAgentVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceAddAgentVoice>): VoiceAddAgentVoice {
    const message = createBaseVoiceAddAgentVoice();
    message.voiceId = object.voiceId ?? "";
    message.probability = object.probability ?? 0;
    message.languageCode = object.languageCode ?? undefined;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseVoiceDeleteAgentVoice(): VoiceDeleteAgentVoice {
  return { voiceId: "", id: "" };
}

export const VoiceDeleteAgentVoice: MessageFns<VoiceDeleteAgentVoice> = {
  encode(message: VoiceDeleteAgentVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceDeleteAgentVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceDeleteAgentVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceDeleteAgentVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: VoiceDeleteAgentVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceDeleteAgentVoice>): VoiceDeleteAgentVoice {
    return VoiceDeleteAgentVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceDeleteAgentVoice>): VoiceDeleteAgentVoice {
    const message = createBaseVoiceDeleteAgentVoice();
    message.voiceId = object.voiceId ?? "";
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseVoiceUpdateAgentVoice(): VoiceUpdateAgentVoice {
  return { voiceId: "", probability: 0, newVoiceId: undefined, id: "" };
}

export const VoiceUpdateAgentVoice: MessageFns<VoiceUpdateAgentVoice> = {
  encode(message: VoiceUpdateAgentVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.probability !== 0) {
      writer.uint32(17).double(message.probability);
    }
    if (message.newVoiceId !== undefined) {
      writer.uint32(26).string(message.newVoiceId);
    }
    if (message.id !== "") {
      writer.uint32(34).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceUpdateAgentVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceUpdateAgentVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.probability = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.newVoiceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceUpdateAgentVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      probability: isSet(object.probability) ? globalThis.Number(object.probability) : 0,
      newVoiceId: isSet(object.newVoiceId)
        ? globalThis.String(object.newVoiceId)
        : isSet(object.new_voice_id)
        ? globalThis.String(object.new_voice_id)
        : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: VoiceUpdateAgentVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.probability !== 0) {
      obj.probability = message.probability;
    }
    if (message.newVoiceId !== undefined) {
      obj.newVoiceId = message.newVoiceId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceUpdateAgentVoice>): VoiceUpdateAgentVoice {
    return VoiceUpdateAgentVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceUpdateAgentVoice>): VoiceUpdateAgentVoice {
    const message = createBaseVoiceUpdateAgentVoice();
    message.voiceId = object.voiceId ?? "";
    message.probability = object.probability ?? 0;
    message.newVoiceId = object.newVoiceId ?? undefined;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseVoiceCreateAgentVoiceSettings(): VoiceCreateAgentVoiceSettings {
  return { voiceId: "", settings: undefined };
}

export const VoiceCreateAgentVoiceSettings: MessageFns<VoiceCreateAgentVoiceSettings> = {
  encode(message: VoiceCreateAgentVoiceSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    switch (message.settings?.$case) {
      case "elevenLabs":
        ElevenLabsTtsConfig.encode(message.settings.value, writer.uint32(18).fork()).join();
        break;
      case "playHt":
        PlayHTTtsConfig.encode(message.settings.value, writer.uint32(58).fork()).join();
        break;
      case "cartesia":
        CartesiaTtsConfig.encode(message.settings.value, writer.uint32(66).fork()).join();
        break;
      case "hume":
        HumeTtsConfig.encode(message.settings.value, writer.uint32(74).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceCreateAgentVoiceSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceCreateAgentVoiceSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.settings = { $case: "playHt", value: PlayHTTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.settings = { $case: "hume", value: HumeTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceCreateAgentVoiceSettings {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      settings: isSet(object.elevenLabs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.elevenLabs) }
        : isSet(object.eleven_labs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.eleven_labs) }
        : isSet(object.playHt)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.playHt) }
        : isSet(object.play_ht)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.play_ht) }
        : isSet(object.cartesia)
        ? { $case: "cartesia", value: CartesiaTtsConfig.fromJSON(object.cartesia) }
        : isSet(object.hume)
        ? { $case: "hume", value: HumeTtsConfig.fromJSON(object.hume) }
        : undefined,
    };
  },

  toJSON(message: VoiceCreateAgentVoiceSettings): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.settings?.$case === "elevenLabs") {
      obj.elevenLabs = ElevenLabsTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "playHt") {
      obj.playHt = PlayHTTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "cartesia") {
      obj.cartesia = CartesiaTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "hume") {
      obj.hume = HumeTtsConfig.toJSON(message.settings.value);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceCreateAgentVoiceSettings>): VoiceCreateAgentVoiceSettings {
    return VoiceCreateAgentVoiceSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceCreateAgentVoiceSettings>): VoiceCreateAgentVoiceSettings {
    const message = createBaseVoiceCreateAgentVoiceSettings();
    message.voiceId = object.voiceId ?? "";
    switch (object.settings?.$case) {
      case "elevenLabs": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "playHt": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "playHt", value: PlayHTTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "cartesia": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "hume": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "hume", value: HumeTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseVoiceUpdateAgentVoiceSettings(): VoiceUpdateAgentVoiceSettings {
  return { voiceId: "", settings: undefined };
}

export const VoiceUpdateAgentVoiceSettings: MessageFns<VoiceUpdateAgentVoiceSettings> = {
  encode(message: VoiceUpdateAgentVoiceSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    switch (message.settings?.$case) {
      case "elevenLabs":
        ElevenLabsTtsConfig.encode(message.settings.value, writer.uint32(18).fork()).join();
        break;
      case "playHt":
        PlayHTTtsConfig.encode(message.settings.value, writer.uint32(58).fork()).join();
        break;
      case "cartesia":
        CartesiaTtsConfig.encode(message.settings.value, writer.uint32(66).fork()).join();
        break;
      case "hume":
        HumeTtsConfig.encode(message.settings.value, writer.uint32(74).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceUpdateAgentVoiceSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceUpdateAgentVoiceSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.settings = { $case: "playHt", value: PlayHTTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.settings = { $case: "hume", value: HumeTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceUpdateAgentVoiceSettings {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      settings: isSet(object.elevenLabs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.elevenLabs) }
        : isSet(object.eleven_labs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.eleven_labs) }
        : isSet(object.playHt)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.playHt) }
        : isSet(object.play_ht)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.play_ht) }
        : isSet(object.cartesia)
        ? { $case: "cartesia", value: CartesiaTtsConfig.fromJSON(object.cartesia) }
        : isSet(object.hume)
        ? { $case: "hume", value: HumeTtsConfig.fromJSON(object.hume) }
        : undefined,
    };
  },

  toJSON(message: VoiceUpdateAgentVoiceSettings): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.settings?.$case === "elevenLabs") {
      obj.elevenLabs = ElevenLabsTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "playHt") {
      obj.playHt = PlayHTTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "cartesia") {
      obj.cartesia = CartesiaTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "hume") {
      obj.hume = HumeTtsConfig.toJSON(message.settings.value);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceUpdateAgentVoiceSettings>): VoiceUpdateAgentVoiceSettings {
    return VoiceUpdateAgentVoiceSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceUpdateAgentVoiceSettings>): VoiceUpdateAgentVoiceSettings {
    const message = createBaseVoiceUpdateAgentVoiceSettings();
    message.voiceId = object.voiceId ?? "";
    switch (object.settings?.$case) {
      case "elevenLabs": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "playHt": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "playHt", value: PlayHTTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "cartesia": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "hume": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "hume", value: HumeTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseVoiceUpdateDisclaimerVoice(): VoiceUpdateDisclaimerVoice {
  return { voiceId: "", languageCode: undefined };
}

export const VoiceUpdateDisclaimerVoice: MessageFns<VoiceUpdateDisclaimerVoice> = {
  encode(message: VoiceUpdateDisclaimerVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.languageCode !== undefined) {
      writer.uint32(18).string(message.languageCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceUpdateDisclaimerVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceUpdateDisclaimerVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceUpdateDisclaimerVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : undefined,
    };
  },

  toJSON(message: VoiceUpdateDisclaimerVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.languageCode !== undefined) {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceUpdateDisclaimerVoice>): VoiceUpdateDisclaimerVoice {
    return VoiceUpdateDisclaimerVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceUpdateDisclaimerVoice>): VoiceUpdateDisclaimerVoice {
    const message = createBaseVoiceUpdateDisclaimerVoice();
    message.voiceId = object.voiceId ?? "";
    message.languageCode = object.languageCode ?? undefined;
    return message;
  },
};

function createBaseVoiceCreateDisclaimerVoiceSettings(): VoiceCreateDisclaimerVoiceSettings {
  return { voiceId: "", settings: undefined };
}

export const VoiceCreateDisclaimerVoiceSettings: MessageFns<VoiceCreateDisclaimerVoiceSettings> = {
  encode(message: VoiceCreateDisclaimerVoiceSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    switch (message.settings?.$case) {
      case "elevenLabs":
        ElevenLabsTtsConfig.encode(message.settings.value, writer.uint32(18).fork()).join();
        break;
      case "playHt":
        PlayHTTtsConfig.encode(message.settings.value, writer.uint32(58).fork()).join();
        break;
      case "cartesia":
        CartesiaTtsConfig.encode(message.settings.value, writer.uint32(66).fork()).join();
        break;
      case "hume":
        HumeTtsConfig.encode(message.settings.value, writer.uint32(74).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceCreateDisclaimerVoiceSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceCreateDisclaimerVoiceSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.settings = { $case: "playHt", value: PlayHTTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.settings = { $case: "hume", value: HumeTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceCreateDisclaimerVoiceSettings {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      settings: isSet(object.elevenLabs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.elevenLabs) }
        : isSet(object.eleven_labs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.eleven_labs) }
        : isSet(object.playHt)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.playHt) }
        : isSet(object.play_ht)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.play_ht) }
        : isSet(object.cartesia)
        ? { $case: "cartesia", value: CartesiaTtsConfig.fromJSON(object.cartesia) }
        : isSet(object.hume)
        ? { $case: "hume", value: HumeTtsConfig.fromJSON(object.hume) }
        : undefined,
    };
  },

  toJSON(message: VoiceCreateDisclaimerVoiceSettings): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.settings?.$case === "elevenLabs") {
      obj.elevenLabs = ElevenLabsTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "playHt") {
      obj.playHt = PlayHTTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "cartesia") {
      obj.cartesia = CartesiaTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "hume") {
      obj.hume = HumeTtsConfig.toJSON(message.settings.value);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceCreateDisclaimerVoiceSettings>): VoiceCreateDisclaimerVoiceSettings {
    return VoiceCreateDisclaimerVoiceSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceCreateDisclaimerVoiceSettings>): VoiceCreateDisclaimerVoiceSettings {
    const message = createBaseVoiceCreateDisclaimerVoiceSettings();
    message.voiceId = object.voiceId ?? "";
    switch (object.settings?.$case) {
      case "elevenLabs": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "playHt": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "playHt", value: PlayHTTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "cartesia": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "hume": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "hume", value: HumeTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseVoiceUpdateDisclaimerVoiceSettings(): VoiceUpdateDisclaimerVoiceSettings {
  return { voiceId: "", settings: undefined };
}

export const VoiceUpdateDisclaimerVoiceSettings: MessageFns<VoiceUpdateDisclaimerVoiceSettings> = {
  encode(message: VoiceUpdateDisclaimerVoiceSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    switch (message.settings?.$case) {
      case "elevenLabs":
        ElevenLabsTtsConfig.encode(message.settings.value, writer.uint32(18).fork()).join();
        break;
      case "playHt":
        PlayHTTtsConfig.encode(message.settings.value, writer.uint32(58).fork()).join();
        break;
      case "cartesia":
        CartesiaTtsConfig.encode(message.settings.value, writer.uint32(66).fork()).join();
        break;
      case "hume":
        HumeTtsConfig.encode(message.settings.value, writer.uint32(74).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceUpdateDisclaimerVoiceSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceUpdateDisclaimerVoiceSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.settings = { $case: "playHt", value: PlayHTTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.settings = { $case: "hume", value: HumeTtsConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceUpdateDisclaimerVoiceSettings {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      settings: isSet(object.elevenLabs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.elevenLabs) }
        : isSet(object.eleven_labs)
        ? { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromJSON(object.eleven_labs) }
        : isSet(object.playHt)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.playHt) }
        : isSet(object.play_ht)
        ? { $case: "playHt", value: PlayHTTtsConfig.fromJSON(object.play_ht) }
        : isSet(object.cartesia)
        ? { $case: "cartesia", value: CartesiaTtsConfig.fromJSON(object.cartesia) }
        : isSet(object.hume)
        ? { $case: "hume", value: HumeTtsConfig.fromJSON(object.hume) }
        : undefined,
    };
  },

  toJSON(message: VoiceUpdateDisclaimerVoiceSettings): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.settings?.$case === "elevenLabs") {
      obj.elevenLabs = ElevenLabsTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "playHt") {
      obj.playHt = PlayHTTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "cartesia") {
      obj.cartesia = CartesiaTtsConfig.toJSON(message.settings.value);
    } else if (message.settings?.$case === "hume") {
      obj.hume = HumeTtsConfig.toJSON(message.settings.value);
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceUpdateDisclaimerVoiceSettings>): VoiceUpdateDisclaimerVoiceSettings {
    return VoiceUpdateDisclaimerVoiceSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceUpdateDisclaimerVoiceSettings>): VoiceUpdateDisclaimerVoiceSettings {
    const message = createBaseVoiceUpdateDisclaimerVoiceSettings();
    message.voiceId = object.voiceId ?? "";
    switch (object.settings?.$case) {
      case "elevenLabs": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "elevenLabs", value: ElevenLabsTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "playHt": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "playHt", value: PlayHTTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "cartesia": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "cartesia", value: CartesiaTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
      case "hume": {
        if (object.settings?.value !== undefined && object.settings?.value !== null) {
          message.settings = { $case: "hume", value: HumeTtsConfig.fromPartial(object.settings.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseVoiceAddFavoriteVoice(): VoiceAddFavoriteVoice {
  return { voiceId: "", accountId: "" };
}

export const VoiceAddFavoriteVoice: MessageFns<VoiceAddFavoriteVoice> = {
  encode(message: VoiceAddFavoriteVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceAddFavoriteVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceAddFavoriteVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceAddFavoriteVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
        ? globalThis.String(object.account_id)
        : "",
    };
  },

  toJSON(message: VoiceAddFavoriteVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceAddFavoriteVoice>): VoiceAddFavoriteVoice {
    return VoiceAddFavoriteVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceAddFavoriteVoice>): VoiceAddFavoriteVoice {
    const message = createBaseVoiceAddFavoriteVoice();
    message.voiceId = object.voiceId ?? "";
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseVoiceRemoveFavoriteVoice(): VoiceRemoveFavoriteVoice {
  return { voiceId: "", accountId: "" };
}

export const VoiceRemoveFavoriteVoice: MessageFns<VoiceRemoveFavoriteVoice> = {
  encode(message: VoiceRemoveFavoriteVoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voiceId !== "") {
      writer.uint32(10).string(message.voiceId);
    }
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoiceRemoveFavoriteVoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceRemoveFavoriteVoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voiceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceRemoveFavoriteVoice {
    return {
      voiceId: isSet(object.voiceId)
        ? globalThis.String(object.voiceId)
        : isSet(object.voice_id)
        ? globalThis.String(object.voice_id)
        : "",
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
        ? globalThis.String(object.account_id)
        : "",
    };
  },

  toJSON(message: VoiceRemoveFavoriteVoice): unknown {
    const obj: any = {};
    if (message.voiceId !== "") {
      obj.voiceId = message.voiceId;
    }
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create(base?: DeepPartial<VoiceRemoveFavoriteVoice>): VoiceRemoveFavoriteVoice {
    return VoiceRemoveFavoriteVoice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VoiceRemoveFavoriteVoice>): VoiceRemoveFavoriteVoice {
    const message = createBaseVoiceRemoveFavoriteVoice();
    message.voiceId = object.voiceId ?? "";
    message.accountId = object.accountId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
